module.exports = __webpack_public_path__ + "img/ranking.eed42fc7.png";